export default "__VITE_ASSET__IE1SOqqV__"